import { ICON_COLOR } from '@zep-us/zus';
import { EyeFillIcon, EyeSlashIcon } from '@zep-us/zus-icons';
import { useTranslation } from 'next-i18next';
import { ANSWER_REVEAL_MODE, type AnswerRevealMode, getAnswerRevealModeLabelKey, resolveAnswerRevealMode } from '@/shared/utils/answerRevealMode';
export interface ShowAnswerBadgeProps {
  /** 정답 표시 여부 */
  showIncorrectAnswer: boolean;
  /** 정답 공개 방식 */
  answerRevealMode?: AnswerRevealMode;
}

/**
 * ShowAnswerBadge - 정답 공개 방식 배지
 *
 * @description
 * 퀴즈 상세에서 정답 공개 방식을 아이콘과 텍스트로 표시합니다.
 * - 항상/틀렸을 때만 표시: 눈 아이콘 + 공개 방식 문구
 * - 미표시: 눈 가림 아이콘 + "정답 미표시"
 */
export const ShowAnswerBadge = ({
  answerRevealMode,
  showIncorrectAnswer
}: ShowAnswerBadgeProps) => {
  const {
    t
  } = useTranslation(['common']);
  const resolvedAnswerRevealMode = resolveAnswerRevealMode({
    answerRevealMode,
    showIncorrectAnswer
  });
  // detail.showAnswerAlways / detail.showAnswerIncorrectOnly 는 NEW 키 — /translate 스텝이 등록한다.
  const label = t(getAnswerRevealModeLabelKey(resolvedAnswerRevealMode));
  return <div className="flex shrink-0 items-center gap-2xs" data-sentry-component="ShowAnswerBadge" data-sentry-source-file="ShowAnswerBadge.tsx">
      <div className="flex size-[16px] items-center justify-center">
        {resolvedAnswerRevealMode !== ANSWER_REVEAL_MODE.NEVER ? <EyeFillIcon size="2xs" fill={ICON_COLOR.neutral} /> : <EyeSlashIcon size="2xs" fill={ICON_COLOR.neutral} />}
      </div>
      <p className="text-caption-lg-semibold text-neutral">{label}</p>
    </div>;
};